import type { FaireProductEntity } from "../../entity_types/product";

export const p_xpsy3xgw89: FaireProductEntity = {
  token: "p_xpsy3xgw89",
  type: "product",
  name: "Umbrella So Sorry Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/f1c27afcba28bad5b2b7ef51e93f985f1e36970bff95567b81c018b602bd4df3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cfe7528caceec499485ce4165cb6eee0940c8f58e4edd6e3794bfb31d5b9a171.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg"
  ],
  priceDollars: 3,
  description: "The comfort of a friend can help get through the rainiest days.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:38.299Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
